<template>
  <!-- 汇总数据 -->
  <div id="collectData">
      <HeadControl :titleName="'汇总数据'" ref="headControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker" />
      <div class="top-Box">
        <div class="left">
          <div class="left-t" v-for="(item,index) in reportList" :key="index">
            <div class="icon">
              <img :src="item.itemIcon" />
            </div>
            <div class="desc">
              <div class="a-title">{{item.itemName}}</div>
              <div class="amount" v-if="item.itemName.includes('金额')">{{aFormat(item.amount)}}<span>元</span></div>
              <div class="amount" v-if="item.itemName.includes('数量')">{{item.count}}<span>个</span></div>
            </div>
          </div>
        </div>
        <div class="Progress" ref="ProgressProportion"></div>
        <div class="sendOrdersBox">
          <div class="sendOrders" ref="SendOrders"></div>
          <div class="nodata_box" v-if="Judge">
            <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
            <span>暂无数据</span>
          </div>
        </div>
      </div>
      <div class="bottom-Box">
        <div class="left-Box">
          <div class="lOne-box">
                <div class="BoxText">项目地区</div>
                <div class="regionData">
                    <div class="BoxData" v-for="(item,index) in RegionDataList" :key="index">
                        <div class="SmBoxData">
                        <div class="region">{{item.itemName}}</div>
                        <div class="number">{{item.count}}<i>个</i></div>               
                        </div>
                        <div class="DataImg">
                            <img :src="item.itemIcon" alt="">
                        </div>
                    </div>
                                                          
                </div>             
          </div>
          <div class="schedule" ref="schedule"></div>
        </div>
        <div class="right-Box" ref="ProjectLevel"></div>
      </div>
  </div>
</template>

<script>
import HeadControl from "@/components/HeadControl";
import * as Urls from '@/helper/Urls';
import {amountFormat} from '@/helper/VueHelper';
export default {
  components:{
    HeadControl
  },
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], // 时间  
      reportList: [],   //签约金额与数量
      ProgressDataList:'', // 进度比例
      SendOrdersDataList:'', // 派单比例
      RegionDataList:'', // 地区数据
      ApplyingProjectList:'', // 报建项目
      ProjectLevelList:'', // 项目等级
      progressLsit:[],
      Judge:'',
      screenWidth:document.body.clientWidth, // 屏幕宽度
    };
  },
  methods:{
    init(){
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal(val){
      this.orgCode = val;
      this.getProgressData()
      this.getSendOrdersData()
      this.getRegion()
      this.getApplyingProject()
      this.getProjectLevel()
      this.getBuyingIsMoneyAndNumber()
    },
    changDate(val){
      this.dataRange = val;
      this.getProgressData()
      this.getSendOrdersData()
      this.getRegion()
      this.getApplyingProject()
      this.getProjectLevel()
      this.getBuyingIsMoneyAndNumber()
    },
    changePicker(val){
      this.dataRange = val;
      this.getProgressData()
      this.getSendOrdersData()
      this.getRegion()
      this.getApplyingProject()
      this.getProjectLevel()
      this.getBuyingIsMoneyAndNumber()
    },
    aFormat(amount) {
      return amountFormat(amount);
    },
    getBuyingIsMoneyAndNumber(){
      let url = Urls.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber
      let params = {
         orgCode: this.orgCode || "",
         startTime: this.dataRange.length ? this.dataRange[0] : "",
         endTime: this.dataRange.length ? this.dataRange[1] : "",        
         contractCat: 'PROJECT'
      }
       this.$root.doPost(url,params,(server_data)=>{
            // 用户没有登录
           if( !this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             this.$root.showGlobalError(server_data.error);
             return;
         }    
          this.reportList = server_data.data.reportList
        })      
    },
    // 获取进度比例
    getProgressData(){
      let _this = this
      let url =  Urls.getEchartsCollectReportDataByProgressRatio
      let params =  {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",        
        itemCode:''
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }    
            _this.ProgressDataList = server_data.data
        })      
    },
    // 进度比例报表
    initChart1() {
      let { legend,series,xAxis} = this.ProgressDataList
      let statePercent = Math.ceil(Math.max(...series[0].data) / 10) * 10
      let stateEntries = Math.ceil(Math.max(...series[1].data) / 10) * 10   
      let Chart1 = this.$echarts.getInstanceByDom(this.$refs.ProgressProportion);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ProgressProportion);
      }      
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '进度比例',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: {
                left:this.$route.query.identification ? '34' : (this.screenWidth <= 1366 ? '8%' : '5%'),
                right: this.$route.query.identification ? '15%' : '4.5%',
                bottom: '20px',
                top:this.$route.query.identification ? '30%' : '90px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  x:this.$route.query.identification ? '110' : '180',
                  y:'24',
                  textStyle: {
                    fontSize: '13',            
                    height: 10,
                     rich: {
                      a: {
                       verticalAlign: 'middle',
                   },
                 }
                },
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      color: '#666666',
                    },                     
                    axisPointer: {
                      type: 'none'
                    }                                  
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    show:Math.max(...series[0].data) == 0 ? false : true,
                    min: 0,
                    max: statePercent,
                    splitNumber:5,
                    interval: statePercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                          color:'#666666'
                        }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                      padding:this.$route.query.identification ? [0,30,0,0] : [0,40,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '数量（个）',
                    show:Math.max(...series[1].data) == 0 ? false : true,
                    min: 0,
                    max: stateEntries,
                    // interval: stateEntries===0 ? 1:stateEntries / (statePercent / 10),
                    splitNumber:5,
                    interval: stateEntries / 5,
                    axisLabel: {
                      formatter: params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                          color:'#666666'
                        }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                       padding: [0,20,0,38]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }                    
                  }
                ],
                series: [
                  {
                    name: series[0].name,
                    type: 'bar',
                    barWidth :this.$route.query.identification ? '50%' : '80%',
                    data: series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,0.35)',
                      borderColor:Math.max(...series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                      }  
                    }
                  },
                  {
                    name: series[1].name,
                    type: 'line',
                    symbol:'rect',
                    symbolSize: 9,
                    yAxisIndex: 1,
                    hoverAnimation: false,
                    data: series[1].data,
                    itemStyle:{
                      normal:{
                      color:'#72d8c0',
                      opacity: series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
                      } ,
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: '#61d9ac',
                      color: '#61d9ac',
                      }, 
                    },
                   lineStyle:{
                      normal:{
                        opacity: series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
                      }
                    },                    
                  },
                  
                ]
              };
        this.myChart1.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth,
            };
            this.myChart1.resize(resize)
          } else {
            this.myChart1.resize()
          }
        })        
    }, 
    // 获取派单比例
    getSendOrdersData(){
      let _this = this
      let url =  Urls.getEchartsCollectReportDataByDispatchRatio
      let params =  {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",        
        itemCode:''
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }    
            _this.SendOrdersDataList = server_data.data
        })        
    },  
    // 派单比例报表
    initChart2(){
        let JudgeConditions = this.$route.query.identification
        const res = this.SendOrdersDataList.every(item=>{
          if(item.value==0) return true
          else false
        })
        this.Judge = res
        let Chart2 = this.$echarts.getInstanceByDom(this.$refs.SendOrders);
        if (Chart2 == null) {
          this.myChart2 = this.$echarts.init(this.$refs.SendOrders);
        }        
        const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                  text: '派单比例',
                  top:'24',  
                  left:this.$route.query.identification ? '20' : '30',
                      textStyle:{
                        fontWeight:500,
                      }
                },
                tooltip: {
                  show:this.$route.query.identification ? true : (this.screenWidth <=1366 ? true : this.screenWidth == 1536 ? true : false) , 
                  trigger: 'item',      
                  formatter:params=>{
                    return `<div style="font-size:14px; padding:4px;">
                                <div>${params.name}：${params.data.value}个</div>
                                <div>占比：${params.data.percent}%</div>
                            </div>`
                 }
                },
                color:["#59b9fe", "#62d8ae","#ffb971"],
                legend: {
                  orient:this.$route.query.identification ? "horizontal" :  "vertical",
                  x:this.$route.query.identification ?  '120':'35',
                  y:this.$route.query.identification ? '24' : '70',
                  itemGap:14,
                  itemWidth: 10,
                  itemHeight: 11,
                  data:this.SendOrdersDataList,
                  formatter: (name)=>{
                         return `{a|${name}}`
                  },
                  textStyle: {
                    color: '#666666',           
                    height: 10,
                     rich: {
                      a: {
                       lineHeight: 14,
                   },
                 }
                },
                },
                series: [
                  {
                    name: '项目类型',
                    stillShowZeroSum:false,
                    type: 'pie',
                    radius:this.$route.query.identification ? ['40%','60%'] : (this.screenWidth <= 1366 ? ['38%','52%'] : this.screenWidth == 1536 ? ['40%', '60%'] : ['35%', '50%']),
                    center:this.$route.query.identification ? ['50%','55%'] : (this.screenWidth <= 1366 ? ['60%','50%'] : ['58%','55%']) ,
                    silent: this.$route.query.identification ? false : (this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ?  false :true) , // 鼠标悬浮高亮
                    itemStyle: {
                      align:'left',
                        normal: {
                        borderWidthLeft: this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1) ,
                        borderColor:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff') ,
                          label: {
                            show:res ? false : true,
                            align:'left',
                            position:this.$route.query.identification ? 'inside' : (this.screenWidth <=1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside') ,
                            padding:[15,0,0,0],
                            color: "#fff",
                            fontSize:this.$route.query.identification ? 15 : 12,
                            formatter: params => {
                               if(JudgeConditions == 'pplet' || this.screenWidth <=1366 || this.screenWidth == 1536){
                                    return params.data.percent == 0 ? '' : `${params.data.percent}%`
                                }else{
                                  return `{left|\n${params.data.name}：${params.data.value}个\n占比：${params.data.percent}%\n}`
                                }
                            },
                            rich: {
                            left: {
                                align:'left',
                                lineHeight:15,
                                color:'#666666'
                            }
                            }                            
                          },
                        },

                    },
                    labelLine:{
                      normal:{
                        show:res ? false : true,
                          length:this.$route.query.identification ? 5 : (this.screenWidth <= 1366 ? 10 : 15),
                          length2:this.$route.query.identification ? 20 : (this.screenWidth <= 1366 ? 30 : 15),
                      }
                    },
                    data: this.SendOrdersDataList,
                  }
                ]
              };
        this.myChart2.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth,
            };
            this.myChart2.resize(resize);
          } else {
            this.myChart2.resize();
          }
      }); 
    },
    // 获取地区数据 
    getRegion(){
      let _this = this
      let url =  Urls.getEchartsCollectReportDataByRegion
      let params =  {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",        
        itemCode:'PROJECT_REGION'
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }    
            _this.RegionDataList = server_data.data.reportList
        })       
    },
    // 获取报建项目
    getApplyingProject(){
      let _this = this
      let url =  Urls.getEchartsCollectReportDataBySource 
      let params =  {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",        
        itemCode:''
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }    
            _this.ApplyingProjectList = server_data.data
        })       
    },
    // 报建项目报表   
    initChart3(){
      let { series , yAxis} = this.ApplyingProjectList
      let Chart3 = this.$echarts.getInstanceByDom(this.$refs.schedule);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.schedule);
      }
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title:{
          text:'报建项目',
          top:'24',  
          left:this.$route.query.identification ? '20' : '30',
          textStyle:{
            fontWeight:500,
          }
        },
        tooltip:{
          show:true,
          trigger:'item',
          formatter:params=>{
          let string = `<div style="padding:4px;">
                          <div>${params.name}：${series[0].data[params.dataIndex]}个</div>
                          <div>占比：${params.value}%</div>
                        </div>
                      `
                      return string
          }
        },
        grid: {
          left:this.$route.query.identification ? '25' :  '32',
          top:this.$route.query.identification ? '55' :  '55',
          right:this.$route.query.identification ? '15' :  '35',
          bottom: this.$route.query.identification ?'18' : '25',
        },
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              formatter: (val, index) => {
                let res = "";
                series[0].data.forEach((item, i) => {
                  if (i == index) {
                    res = item;
                  }
                });
                return val + `（${res}个）`;
              },
              textStyle: {
                color: "#666666",
                fontSize: "14",
                lineHeight: 20,
              },
              padding: [0, -100, 35, 10],
              align: 'left',
              rich: {}
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: yAxis.data,
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            position: "left",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#57b9ff",
                fontSize: "14",
              },
              padding: [0, -45, -45, 15],
              formatter: "({value}%)",
              align: 'left',
              rich: {}
            },
            data: series[0].percent,
          },
        ],
        series: [
          {
            type: "bar",
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: "#57b9ff",
              },
            },
            barWidth: 10,
            data: series[0].percent,
          },
          {
            type: "bar",
            silent: true,
            barWidth: 10,
            barGap: "-100%",
            data: this.progressLsit,
            itemStyle: {
              normal: {
                color: "#eeeeee",
                barBorderRadius: 10,
              },
            },
          },
        ],
      }
      this.myChart3.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart3.resize(resize);
        } else {
          this.myChart3.resize();
        }
      }); 
    },    
    // 获取项目等级
    getProjectLevel(){
      let _this = this
      let url =  Urls.getEchartsCollectReportDataByGrade 
      let params =  {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",        
        itemCode:'CONTRACT_LEVEL'
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }    
            _this.ProjectLevelList = server_data.data
        })       
    },
    // 项目等级数据报表
    initChart4() {
      let { legend,series,xAxis} = this.ProjectLevelList
      let statePercent = Math.ceil(Math.max(...series[0].data) / 10) * 10
      let stateEntries = Math.ceil(Math.max(...series[1].data) / 10) * 10   
      let Chart4 = this.$echarts.getInstanceByDom(this.$refs.ProjectLevel);
      if (Chart4 == null) {
        this.myChart4 = this.$echarts.init(this.$refs.ProjectLevel);
      }      
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '项目等级',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: {
                left: this.$route.query.identification ? '32' : (this.screenWidth <= 1366 ? '8%' : '6%'),
                right:this.$route.query.identification ? '10%' :  '4.5%',
                bottom: '20px',
                top:this.$route.query.identification ? '25%' : '90px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' : '180',
                  top:'24',
                  textStyle: {
                    fontSize: '13',            
                    height: 10,
                     rich: {
                      a: {
                       verticalAlign: 'middle',
                   },
                 }
                },
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      color: '#666666',
                    },                     
                    axisPointer: {
                      type: 'none'
                    }                                  
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    show:Math.max(...series[0].data) == 0 ? false : true,
                    min: 0,
                    max: statePercent,
                    splitNumber:5,
                    interval: statePercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                          color:'#666666'
                        }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                      padding:this.$route.query.identification ? [0,22,0,0] : [0,40,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '数量（个）',
                    show:Math.max(...series[1].data) == 0 ? false : true,
                    min: 0,
                    max: stateEntries,
                    // interval: stateEntries===0 ? 1:stateEntries / (statePercent / 10),
                    splitNumber:5,
                    interval: stateEntries / 5,
                    axisLabel: {
                      formatter: params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                        color:'#666666'
                      }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                       padding:this.$route.query.identification ? [0,15,0,38] : [0,20,0,38]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }                    
                  }
                ],
                series: [
                  {
                    name: series[0].name,
                    type: 'bar',
                    barWidth :this.$route.query.identification ? '30%'  : (this.screenWidth <= 1366 ? '50%' : '70%'),
                    data: series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,0.35)',
                      borderColor:Math.max(...series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                      }  
                    },
                  },
                  {
                    name: series[1].name,
                    type: 'line',
                    symbol:'rect',
                    symbolSize: 9,
                    yAxisIndex: 1,
                    hoverAnimation: false,
                    data: series[1].data,
                    itemStyle:{
                      normal:{
                      color:'#72d8c0',
                      opacity:series[1].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
                      } ,
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: '#61d9ac',
                      color: '#61d9ac',
                      },
                    },
                    lineStyle:{
                      normal:{
                        opacity: series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
                      }
                    },
                  },
                  
                ]
              };
      this.myChart4.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart4.resize(resize)
        } else {
          this.myChart4.resize()
        }
      })       
    },    
  },
  mounted(){
    let _this = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth + 17; //实时宽度
        _this.screenWidth = window.screenWidth;
      })();
    };  
    console.log(this.screenWidth)
  },
  watch:{
    ProgressDataList(){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })
      this.initChart1()
    },
    SendOrdersDataList(val){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })
      this.initChart2()
    },
    ApplyingProjectList(val){
      for(let i = 0;i < val.series[0].data.length;i++){
        this.progressLsit.push(100)
      }   
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })         
      this.initChart3()
    },
    ProjectLevelList(){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })      
      this.initChart4()
    },
  }
}
</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
#collectData{
  .top-Box{
    display: flex;
    margin-top: 0.29rem;
    justify-content: space-between;
    .left {
      // width: calc(30% - 0.6rem - 0.24rem);
      width: 30%;
      box-sizing: border-box;
      padding: 0 0.3rem;
      margin-right: 0.24rem;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      .left-t {
        display: flex;
        // justify-content: center;
        align-items: center;
        padding: 0.55rem 0 0.5rem 0.2rem;
        border-bottom: 1px solid #eee;
        .icon {
          width: 0.75rem;
          height: 0.75rem;
          margin-right: 0.35rem;
        }
        .desc {
          .a-title {
            font-size: 0.14rem;
            color: #666666;
            margin-bottom: 0.05rem;
          }
          .amount {
            font-size: 0.26rem;
            color: #333;
            span {
              font-size: 0.14rem;
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .Progress{
      width: 40%;
      margin-right: 0.24rem;
    }
    .sendOrdersBox{
      width: 30%;
    }
    .Progress,.sendOrdersBox{
        position: relative;
        box-sizing: border-box;
        height: 3.7rem;
        // width: calc(50% - 0.12rem);
        background-color: #fff;
        border: 1px solid #EBEEF5;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 0.1rem;
      .nodata_box{
        position: absolute;
        top: 0.26rem;
        left: 47%;
        height: 342px;
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
      span{
        font-size: 16px;
        color: #666666;
        line-height: 44px;
      }
      } 
    .sendOrders{
      width: 100%;
      height:100%;
    }
    }
  }
  .bottom-Box{
      display: flex;
      justify-content: space-between;;
      margin-top: 0.24rem;
    .left-Box{
      width: calc(60% - 0.12rem);
      .lOne-box,.schedule{
          width: 100%;
          border: 1px solid #EBEEF5;
          height: 1.7rem;
          background-color: #fff;
          -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          border-radius: 0.1rem;                                           
      }
      .lOne-box{
        .BoxText{
            font-size: 0.18rem;
            padding-top: 0.24rem;
            padding-left: 0.3rem;
        }
        .regionData{
        display: flex;
        .BoxData{
            display: flex;
            height: 1rem;
            width: 30%;
            margin-left: 0.3rem;
            justify-content: space-between;
            padding-right: 0.16rem;
            border-right: 1px solid #f3f3f3;
            .SmBoxData{
            .region{
                font-size: 0.08rem;
                color:#666666;
                margin-top: 0.25rem;
            } 
            // .regionB{
            //     font-size: 0.08rem;
            //     color:#666666;
            //     margin-top: 0.1rem;
            //     i{
            //         font-style: normal;
            //     }
            // }                  
            .number{
                // line-height: .78rem;
                // margin-right: 0.32rem;
                font-size: 0.25rem;
                margin-top: 0.1rem;
                color:#333333;
                i{
                    font-style: normal;
                    font-size:0.12rem;
                }
            }                    
            }
            .DataImg{
                height: 0.78rem;
                width: 1.08rem;
                margin-top: 0.11rem;
                // border-radius:50%;
                img{
                    width: 1rem;
                }
            }
        }
        // .BoxData:nth-child(1){
        //     padding-right: 0.16rem;
        //     border-right: 1px solid #f3f3f3;

        // }
        .BoxData:nth-child(3){
            border-right:none;
            .DataImg{
                margin-top: 0.2rem;
            }
        }             
        }          
      }
      .schedule{
        margin-top: 0.24rem;
        height: 2.26rem;
      }
    }
    .right-Box{
      width: calc(40% - 0.12rem);
      height: 4.2rem;
      border: 1px solid #EBEEF5;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      border-radius: 0.1rem;
    }
  }
}
@media screen and (max-width: 768px){
  #collectData{
    .top-Box{
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      margin-top: 0.14rem;
      padding: 0 0.12rem;
      width: 100%;
      .Progress,.sendOrdersBox{
        width: 100%;
        border: none;
        background-color: #fff !important;
      }
      .sendOrdersBox{
        margin-top: 0.14rem;
        .nodata_box{
          left: 40%;
        }
      }
    }
    .bottom-Box{
      display: flex;
      flex-direction: column;
      padding: 0 0.12rem;
      margin-top: 0.12rem;
      box-sizing: border-box;
      .left-Box{
        width: 100%;
        .lOne-box{
          width: 100%;
          height: 3.6rem;
          padding: 0.24rem;
          border: none;
          box-sizing: border-box;
          .BoxText{
            padding-top: 0;
            padding-left: 0;
          }
          .regionData{
            flex-direction: column;
            .BoxData{
              padding-right: 0; 
              border-right: none;
              width: 100%;
              margin-left: 0;
              border-bottom: 1px solid #f3f3f3;
              &:last-child{
                border-bottom: none;
              }
            }
          }
        }
        .schedule{
          width: 100%;
          margin-top: 0.12rem;
          border: none;
          background-color: #fff !important;
        }
      }
      .right-Box{
        width: 100%;
        background-color: #fff !important;
        border: none;
        margin-top: 0.12rem;
      }
    }
  }
}
@media screen and (max-width: 1550px) {
  #collectData .top-Box .left .left-t{
    padding-left: 0;
  }
  #collectData .top-Box .left .left-t .desc .amount{
    font-size: 0.15rem;
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 768px){
  #collectData{
  .queryCondition{
    margin-bottom: 0;
  }
  .top-Box{
    .left{
      width: 100% !important;
      margin-bottom: 0.14rem;
      .left-t{
        padding: 0.2rem 0 0.2rem 0.2rem!important;
      }
    }
  }
  }
}
</style>


// WEBPACK FOOTER //
// collectData.vue?5bf9c20b